module.exports = __webpack_public_path__ + "img/icon73.4aefd456.png";